/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Stage } from '../enums';
import { ContainerExplanation } from './ContainerExplanation';

interface IWelcomeStageProps {
  setStage: (stage: Stage) => void;
}

const WelcomeStage = ({ setStage }: IWelcomeStageProps) => {
  return (
    <Box className="block" sx={{ textAlign: 'center' }}>
      <Typography
        align="center"
        className="container-title"
        component="h5"
        variant="h4"
      >
        Welcome
      </Typography>
      <Typography align="center" mt={1}>
        Welcome to the streamGo tech check page
      </Typography>
      <Typography align="center" m={1}>
        Please choose start test which will run through some tests, see below
        some of the tests which will be carried out.
      </Typography>

      <Grid alignItems="stretch" container={true} margin={'30px 0'} spacing={0}>
        <ContainerExplanation
          description="This tool attempts to connect to a conference for 30 seconds and obtain information about the network connection."
          title="Connection"
        />
        <ContainerExplanation
          description="This tool will test your internet connection speed, this will be a good gauge of the quality of call you will send/receive."
          title="Speed Test"
        />
        <ContainerExplanation
          description="This tool gathers your device information. Please make sure to allow camera & microphone access when starting the test."
          title="Hardware"
        />
        <ContainerExplanation
          description="This tool checks if you have a good network connection. A graph will be displayed to present the Audio and Video bitrate."
          title="Call Quality"
        />
      </Grid>
      <Button
        color="primary"
        onClick={() => setStage(Stage.ChooseConfiguration)}
        variant="contained"
      >
        Start Test
      </Button>
    </Box>
  );
};

export default WelcomeStage;
